var _excluded = ["className", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import CkIcon from "../private/CkIcon";
import { nanoid } from "nanoid/non-secure";
var CrossMd = /*#__PURE__*/React.forwardRef((props, ref) => {
  var _props = _extends({}, props),
    {
      className,
      title
    } = _props,
    rest = _objectWithoutPropertiesLoose(_props, _excluded);
  var titleId = props != null && props.id ? props.id + "-title" : nanoid(5);
  return /*#__PURE__*/React.createElement(CkIcon, _extends({
    className: ["CK__Icon--medium", className].filter(Boolean).join(" "),
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": title ? titleId : undefined
  }, rest), title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.854 2.854a.5.5 0 0 0-.708-.708L8 7.293 2.854 2.146a.5.5 0 0 0-.708.708L7.293 8l-5.147 5.146a.5.5 0 0 0 .708.708L8 8.707l5.146 5.147a.5.5 0 0 0 .708-.708L8.707 8l5.147-5.146Z",
    fill: "currentColor"
  }));
});
CrossMd.displayName = "CrossMd";
export default CrossMd;